import { FirebaseFile } from "@/data/providers/files-provider";

export class ProjectsState {
	public projects: Array<FirebaseFile> = [];

	public isBusy: boolean = false;
}